import type { FC } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const _NoStoresError: FC<{ query: string; className?: string }> = ({ query, className }) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <h3>{t('No results for query', { query, context: query === '' ? 'noQuery' : null })}</h3>
      <img alt="errorimage" src="/icons/store-not-found.svg" />
    </div>
  )
}

export const NoStoresError = styled(_NoStoresError)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${theme.spacings.xxLarge} 0`,
  rowGap: theme.spacings.xxLarge,

  h3: theme.variants.title1,
  img: {
    width: '180px',
  },
}))
